import React from 'react';
import PlatformDetailPage from './PlatformDetailPage';

const BrontoAIPage = () => <PlatformDetailPage platformId="brontoai" />;

export default BrontoAIPage;
